import ApolloClient from 'apollo-boost';
import * as Sentry from '@sentry/browser';
import { useAuth0 } from './react-auth0-spa';
import { handleApolloError } from './apolloClientErrors';

function useApolloClient(getTokenSilently) {
  const { logout } = useAuth0();

  return new ApolloClient({
    uri: import.meta.env.VITE_GRAPHQL_SERVER,
    request: async (operation) => {
      const token = await getTokenSilently();

      operation.setContext({
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    onError: ({ graphQLErrors, networkError, response }) => {
      handleApolloError({
        graphQLErrors,
        networkError,
        response,
        logout,
        captureException: Sentry.captureException,
        captureMessage: Sentry.captureMessage,
      });
    },
  });
}

export default useApolloClient;
